var map = {
	"./alpha_tauri.svg": 7805,
	"./alpine.svg": 8170,
	"./aston_martin.svg": 8092,
	"./ferrari.svg": 4212,
	"./formula_one.svg": 740,
	"./haas.svg": 5352,
	"./kick_sauber.svg": 3784,
	"./mclaren.svg": 9126,
	"./mercedes.svg": 1690,
	"./red_bull.svg": 9937,
	"./visa_cashapp_rb.svg": 3759,
	"./williams.svg": 5133
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(function() {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 1370;
module.exports = webpackAsyncContext;